import { BoldLabelText } from '@/components/BoldLabelText/BoldLabelText';
import {
  DescriptionCaption,
  DescriptionCol,
  DescriptionRow,
} from '@/components/Description';
import {
  TransactionItemDrawerMode,
  TransactionItemDrawerModeEnum,
  TransactionItemFormType,
} from '@/features/transaction_items/List/type';
import { useTranslation } from '@/i18n';
import { FormCheckbox, Label } from '@moneyforward/ap-frontend-components';
import { UseFormReturn } from 'react-hook-form';

export type Props = {
  mode: TransactionItemDrawerMode;
  formProps: UseFormReturn<TransactionItemFormType>;
};

export const RequiredSettingCheckbox = ({ mode, formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <DescriptionRow>
      <DescriptionCol
        label={
          <Label testId='required'>
            <BoldLabelText>
              {t('transaction_items.drawer.is_required')}
            </BoldLabelText>
          </Label>
        }
        labelWidth='176px'
      />
      <DescriptionCol
        value={
          <>
            {mode === TransactionItemDrawerModeEnum.DETAIL ? (
              <div>
                {formProps.getValues('is_required')
                  ? t('transaction_items.drawer.is_required.true')
                  : t('transaction_items.drawer.is_required.false')}
              </div>
            ) : (
              <div>
                <FormCheckbox<TransactionItemFormType>
                  name='is_required'
                  control={formProps.control}
                  inputId='is_required'
                  testId='requited'
                  label={t('transaction_items.drawer.is_required.true')}
                />
                <DescriptionCaption>
                  {t('transaction_items.drawer.is_required.description')}
                </DescriptionCaption>
              </div>
            )}
          </>
        }
      />
    </DescriptionRow>
  );
};
RequiredSettingCheckbox.displayName = 'RequiredSettingCheckbox';
